import { useLocation as useLocationReactDom } from 'react-router-dom';
export const useLocation = () => {
    const props = useLocationReactDom();
    const hash = props.hash.replace('#', '') || '';
    const finalProps = {
        ...props,
        hash,
    };
    return finalProps;
};
